import React, { useContext } from 'react';
import { ClassroomContext } from '../../context/ClassroomContext';

const ClassroomSettings = () => {
    const { classroom, isOwner, deleteClassroom } = useContext(ClassroomContext);

    const handleDeleteClassroom = () => {
        if (classroom && window.confirm('Are you sure you want to delete this classroom? This action cannot be undone.')) {
            deleteClassroom(classroom._id); 
        }
    };

    return (
        <div>
            <h1>Settings</h1>
            {isOwner ? (
                <>
                    <h2>Owner Settings</h2>
                    <button onClick={handleDeleteClassroom}>Delete Classroom</button>
                </>
            ) : (
                <h2>Member Settings</h2>
                
            )}
        </div>
    );
};

export default ClassroomSettings;
